<template>
    <div class="datatable-input">
        <i v-if="icon" :class="[icon]"></i>
        <input type="text" v-model="valueModel" :placeholder="placeholder"/>
    </div>
</template>

<script>

export default {
    name: "InputComponent",
    emits: ['update:value'],
    props: {
        value: {
            type: String,
            default() {
                return null;
            }
        },
        icon: {
            type: String,
            default() {
                return null;
            }
        },
        placeholder: {
            type: String,
            default() {
                return null;
            }
        },
    },
    computed: {
        valueModel: {
            get() {
                return this.value
            },
            set(newValue) {
                this.$emit('update:value', newValue)
            }
        },
    }
}
</script>

<style scoped>
.datatable-input {
    border: 2px solid #f5f5f5;
    border-radius: 0.125rem;
    background: #fbfbfb;
    padding: 0 12px;
    display: flex;
    transition: border 0.2s;
}

.datatable-input input, .datatable-input i{
    line-height: 30px;
}

.datatable-input input{
    margin: unset;
    padding: unset;
    border: unset;
    background: #fbfbfb;
}

.datatable-input input:focus {
    outline: none;
}

.datatable-input i{
    font-size: 12px;
    margin-right: 10px;
}
</style>
